import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_INSTITUTE_LIST,
    getInstituteListFail,
    getInstituteListSuccess
} from '../action/getInstituteListAction'

// api 
import getInstituteListApi from '../api/getInstituteListApi'

export function* getInstituteListSaga(action) {
    try {
        const response = yield call(() => getInstituteListApi(action.params))
        if (response.data.status === 1) {
            yield put(getInstituteListSuccess(response, action))
        } else {
            yield put(getInstituteListFail(response, action))
        }
    }
    catch (e) {
        yield put(getInstituteListFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_INSTITUTE_LIST, getInstituteListSaga)
}